import apiUrl from '../../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'ebn-tracking',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      searchType: 'bag',
      bagNumber: '',
      awbNumber: '',
      searchResults: [],
      isSearchLoading: false,
      searchAttempted: false
    }
  },
  computed: {},
  mounted() {},
  methods: {
    async onSearchSubmit() {
      // Manual validation based on search type
      const searchValue = this.searchType === 'bag' ? this.bagNumber.trim() : this.awbNumber.trim();
      
      if (!searchValue) {
        this.$alertify.error(`Please enter ${this.searchType === 'bag' ? 'bag number' : 'AWB number'}`);
        return false;
      }
      
      this.searchEBNTracking();
    },
    searchEBNTracking() {
      const searchValue = this.searchType === 'bag' ? this.bagNumber.trim() : this.awbNumber.trim();
      
      if (!searchValue) {
        this.$alertify.error(`Please enter ${this.searchType === 'bag' ? 'bag number' : 'AWB number'}`);
        return;
      }

      this.isSearchLoading = true;
      this.searchResults = [];
      this.searchAttempted = true;

      const queryParam = this.searchType === 'bag' ? `bagNumber=${searchValue}` : `parentAwb=${searchValue}`;

      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getEBNPartBTrackingLogs?' + queryParam,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
      .then(result => {
        this.isSearchLoading = false;
        if (result.data.ResultCode == 100) {
          const logs = result.data.ResponseData || [];
          
          // Extract shipment details with status
          const shipmentDetails = [];
          const isBagSearch = this.searchType === 'bag';
          
          logs.forEach(log => {
            const status = log.status || '-';
            const errorMessage = log.errorMessage;
            const createdDate = log.createdDate || log.createdDateGMT || '-';
            
            // Handle responseData - can be array or object with data property
            let dataArray = [];
            if (log.responseData) {
              if (Array.isArray(log.responseData)) {
                dataArray = log.responseData;
              } else if (log.responseData.data && Array.isArray(log.responseData.data)) {
                dataArray = log.responseData.data;
              }
            }
            
            // Get EBN codes and messages from responseData
            if (dataArray.length > 0) {
              dataArray.forEach(item => {
                const detail = {
                  parentAwb: log.parentAwb || '-',
                  bagNumber: item.bagno || log.bagNumber || '-',
                  ewayBillNo: item.ewayBillNo || '-',
                  ebnMessage: item.ebnMessage || errorMessage || '-',
                  status: status,
                  createdDate: createdDate,
                  isFailed: status === 'failed' || status === 'partial_failure' || status === 'error'
                };
                
                // Add shippingId only for bag search (check both shippingid and shippingId)
                if (isBagSearch) {
                  detail.shippingId = item.shippingid || item.shippingId || log.shippingId || '-';
                }
                
                shipmentDetails.push(detail);
              });
            } else {
              // If no responseData, still show the record with error message
              const detail = {
                parentAwb: log.parentAwb || '-',
                bagNumber: log.bagNumber || '-',
                ewayBillNo: '-',
                ebnMessage: errorMessage || '-',
                status: status,
                createdDate: createdDate,
                isFailed: status === 'failed' || status === 'partial_failure' || status === 'error'
              };
              
              // Add shippingId only for bag search
              if (isBagSearch) {
                detail.shippingId = log.shippingId || '-';
              }
              
              shipmentDetails.push(detail);
            }
          });

          // Sort: first by createdDate descending (latest first), then by failed status
          shipmentDetails.sort((a, b) => {
            // First sort by createdDate descending (latest first)
            const timeA = new Date(a.createdDate).getTime();
            const timeB = new Date(b.createdDate).getTime();
            if (timeA !== timeB) {
              return timeB - timeA;
            }
            // Then sort by failed status (failed first)
            if (a.isFailed !== b.isFailed) {
              return a.isFailed ? -1 : 1;
            }
            return 0;
          });

          this.searchResults = shipmentDetails;
          
          if (shipmentDetails.length > 0) {
            const errorCount = shipmentDetails.filter(s => s.isFailed).length;
            this.$alertify.success(`Found ${shipmentDetails.length} record(s) - ${errorCount} with errors`);
          } else {
            this.$alertify.success('No records found');
          }
        } else {
          this.$alertify.error(result.data.ReturnMessage || 'Failed to fetch EBN logs');
        }
      })
      .catch(error => {
        this.isSearchLoading = false;
        console.error('EBN tracking search error:', error);
        this.$alertify.error('Error fetching tracking details');
      });
    },
    resetSearch() {
      this.bagNumber = '';
      this.awbNumber = '';
      this.searchResults = [];
      this.searchAttempted = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/EBNTracking/EBNTracking.js